import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import { encapsulation } from '../encapsulation';
import { UBXContainerType } from '../../models';

@Component({
    selector: 'ubx-container',
    templateUrl: './container.component.html',
    host: { class: 'ubx-container' },
    encapsulation
})
export class UBXContainer implements OnInit {
    @Input() type: UBXContainerType = UBXContainerType.Default;

    constructor(
        private renderer: Renderer2,
        public el: ElementRef,
    ) { }

    ngOnInit() {
        this.setType(this.type);
    }

    setType(type: UBXContainerType) {
        if (type) {
            this.appendClass(String(this.type));
        }
    }

    private appendClass(name: string) {
        this.renderer.addClass(this.el.nativeElement, name);
    }
}
